import React, { ReactElement } from 'react';
import { ImageCustom } from '../../../../common/components/ImageCustom';
import { isToday } from '../../../../common/utils/utils';
import moment from 'moment';
import { Link } from 'react-router-dom';
import '../LiveBlock/LiveBlock.scss';

type UserStream = {
  id: string;
  scheduleStartDateTime: string;
  sessionId: string;
  userId: string;
  userLoginId: string;
  userPictureUri: string;
};

type Props = {
  user: UserStream;
};

function UserStreamBlock({ user }: Props): ReactElement {
  return (
    <Link to={`/timeline/${user.userId}`}>
      <div className="live-block">
        <ImageCustom className="live-block__bg" src={user.userPictureUri} />
        <div className="live-block__content">
          {user.scheduleStartDateTime ? (
            <div className="live-block__content__label live-block__content__schedule">
              {!isToday(user.scheduleStartDateTime)
                ? `次回 ${moment(user.scheduleStartDateTime).format(
                    'MM/DD HH:mm',
                  )}`
                : `次回 本日 ${moment(user.scheduleStartDateTime).format(
                    'HH:mm',
                  )}`}
            </div>
          ) : (
            <div></div>
          )}
          <div className="live-block__content__name">{user.userLoginId}</div>
        </div>
      </div>
    </Link>
  );
}

export default UserStreamBlock;
